import React from 'react'
import cl from 'classnames'

import styles from './styles.module.scss'

type Type = 'h1' | 'h2' | 'h3' | 'h4'

type TitleProps = {
	className?: string
	type: Type
}

const Title: React.FC<TitleProps> = ({ children, className, type, ...props }) => {
	const Component = type
	const fontClassName = `${type}Font`

	return (
		<Component className={cl(className, styles[fontClassName], styles.title)} {...props}>
			{children}
		</Component>
	)
}

export default Title
